import { Stack } from '@mui/material'
import { useFormContext, useWatch } from 'react-hook-form'

import { ControlledDatePicker, ControlledSelector } from 'components/common/controller-wrapper'
import { SUPPLIER_ACTIVATION_PERIODS, VEHICLE_TYPES } from 'components/reports/Metrics/constants'
import { NEGOTIATION_OVERVIEW_EARLIEST_DATE } from 'components/reports/Metrics/constants/NegotiationOverview'

import { NegotiationOverviewExportButton } from './NegotiationOverviewExportButton'
import { NegotiationOverviewFilterValues } from './NegotiationOverviewFilterCriteria'
import { NegotiationOverviewServiceCodeAutocomplete } from './NegotiationOverviewServiceCodeAutocomplete'

export const NegotiationOverviewFiltersForm = () => {
  const { control } = useFormContext<NegotiationOverviewFilterValues>()
  const period = useWatch({ control, name: 'period' })
  const customStart = useWatch({ control, name: 'customStart' })
  const customEnd = useWatch({ control, name: 'customEnd' })
  const isCustom = period === 'custom'

  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      spacing={2}
      useFlexGap
      flexWrap='wrap'
      justifyContent={{ xs: 'flex-start', lg: 'flex-end' }}
      alignItems={{ xs: 'stretch', sm: 'flex-end' }}>
      <ControlledSelector
        control={control}
        name='period'
        label='Period'
        options={SUPPLIER_ACTIVATION_PERIODS}
        size='small'
        fullWidth={false}
        sx={{ minWidth: 160 }}
      />

      {isCustom && (
        <>
          <ControlledDatePicker
            control={control}
            name='customStart'
            label='From'
            minDate={NEGOTIATION_OVERVIEW_EARLIEST_DATE}
            maxDate={customEnd ?? new Date()}
            size='small'
            fullWidth={false}
            sx={{ minWidth: 150 }}
          />
          <ControlledDatePicker
            control={control}
            name='customEnd'
            label='To'
            minDate={customStart ?? NEGOTIATION_OVERVIEW_EARLIEST_DATE}
            maxDate={new Date()}
            size='small'
            fullWidth={false}
            sx={{ minWidth: 150 }}
          />
        </>
      )}

      <NegotiationOverviewServiceCodeAutocomplete />

      <ControlledSelector
        control={control}
        name='vehicleType'
        label='Vehicle type'
        options={VEHICLE_TYPES}
        size='small'
        fullWidth={false}
        sx={{ minWidth: 170 }}
      />

      <NegotiationOverviewExportButton />
    </Stack>
  )
}
